// extracted by mini-css-extract-plugin
module.exports = {"flower":"falling-flower_flower__iSGXV","fallingFlower":"falling-flower_fallingFlower__NB7jr"};